import script from "./LandingHeroSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingHeroSection.vue?vue&type=script&setup=true&lang=js"

import "./LandingHeroSection.vue?vue&type=style&index=0&id=33dea83a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dea83a"]])

export default __exports__